// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2m-1";
export var rateTableServiceLevelDropdown = "_2m-3";
export var rateTableTypeDropdown = "_2m-0";
export var rateTableValueModeDropdown = "_2m-2";